import { Injectable } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs'
import { FuseqRaidenService } from './fuseqRaiden.service'
import { RaidenContext } from './fuseqRaiden.model'

@Injectable({ providedIn: 'root' })
export class RaidenRoutingService {
  private currentRoom: string | null = null
  private contextRoom: string | null = null
  private lastRoomObj: { room: string, context?: RaidenContext | null } | null = null
  constructor(
    private readonly router: Router,
    private readonly raiden: FuseqRaidenService
  ) {
    // cambi di route
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // rimuovere dalla url i parametri di query prima di usare come room
        const urlWithoutQueryParams = event.urlAfterRedirects.split('?')[0]
        this.updateRoom(urlWithoutQueryParams)
      })

    // cambi di contesto di editing
    this.raiden.getRaidenContext().subscribe(context => {
      // rimuovere dalla url i parametri di query prima di usare come room
      const urlWithoutQueryParams = this.router.url.split('?')[0]
      this.updateRoom(urlWithoutQueryParams, context)
    })

    // Le room del server vengono perse ad ogni riconnessione del socket: senza
    // rientrare, gli eventi push (es. NRD_DATA) non arrivano piu' fino al refresh.
    this.raiden.onConnect().subscribe(() => {
      if (this.lastRoomObj) {
        console.log('rejoining room after reconnect:', this.lastRoomObj)
        this.raiden.joinRoom(this.lastRoomObj)
      }
    })
  }

  private updateRoom(url: string, context?: RaidenContext | null) {
    const baseRoom = url
    const roomObj = {
      room: baseRoom,
      context
    }
    const contextRoom = context ? `context:${baseRoom}:action:${context.action}:id:${context.obj?.id}` : null

    if (baseRoom !== this.currentRoom) {
      console.log('joining newRoom:', roomObj, 'leaving:', this.currentRoom)
      if (this.currentRoom) {
        this.raiden.leaveRoom(this.currentRoom)
      }
      if (this.contextRoom) {
        this.raiden.leaveRoom(this.contextRoom)
      }
      this.joinRoom(roomObj)
      this.currentRoom = baseRoom
      this.contextRoom = contextRoom
    }
    if (baseRoom == this.currentRoom && contextRoom != this.contextRoom) {
      console.log('updating context in room:', roomObj)
      if (this.contextRoom) {
        this.raiden.leaveRoom(this.contextRoom)
      }
      this.joinRoom(roomObj)
      this.contextRoom = contextRoom
    }
  }

  private joinRoom(roomObj: { room: string, context?: RaidenContext | null }) {
    this.raiden.joinRoom(roomObj)
    this.lastRoomObj = roomObj
  }
}
